/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class CertExamCourse extends Sv {
    constructor() {
        super();
        this.baseUrl += '/certExamCourse';
    }

    data({ courseName, courseStatus, schoolOrgId, courseAuthType, currentPage, pageSize } = {}) {
        return super.get('/data', {
            courseName,
            courseStatus,
            schoolOrgId,
            courseAuthType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { fileBasePath } = json.data.data;
            const { courseImage } = json.data.data.certExamCourse;
            if (!courseImage) {
                json.data.data.certExamCourse.courseImage = [];
            } else {
                json.data.data.certExamCourse.courseImage = courseImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save1({ id, courseName, courseImage, courseHour, courseDesc, schoolOrgId, courseAuthType, courseAuthRate } = {}) {
        const courseImageStr = courseImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save1', {
            id,
            courseName,
            courseImage: courseImageStr,
            courseHour,
            courseDesc,
            schoolOrgId,
            courseAuthType,
            courseAuthRate,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    release({ ids } = {}) {
        return super.post('/release', {
            ids,
        });
    }

    cancelRelease({ ids } = {}) {
        return super.post('/cancelRelease', {
            ids,
        });
    }
}

export default new CertExamCourse();
export { CertExamCourse };
